import * as location from 'src/utils/location'

export default {
  url_to (path, subdomain = null) {
    if (!subdomain) {
      return process.env.URL_SELLER.replace('%s', location.getUsername()) + '/api/' + this.parse_path(path)
    } else {
      return process.env.URL_SELLER.replace('%s', subdomain) + '/api/' + this.parse_path(path)
    }
  },
  url_to_me (path) {
    return process.env.URL_SELLER.replace('%s', location.getUsername()) + '/api/sellers/me' + this.parse_path(path)
  },
  url_to_customer (path) {
    return process.env.URL_SELLER.replace('%s', location.getUsername()) + '/api/customers/me/' + this.parse_path(path)
  },
  url_to_user (path) {
    return process.env.URL_SELLER.replace('%s', location.getUsername()) + '/api/users/' + this.parse_path(path)
  },
  parse_path (path) {
    if (path === undefined) {
      path = ''
    }
    return path
  }
}



// WEBPACK FOOTER //
// ./src/utils/server.js